__turbopack_context__.v({
  "active": "TapNgoTimer-module-scss-module__ULCjVW__active",
  "disabled": "TapNgoTimer-module-scss-module__ULCjVW__disabled",
  "main": "TapNgoTimer-module-scss-module__ULCjVW__main",
});
